<template lang="pug">

.pm
    Loading(v-show="initialFail && !isPreMatchLoaded")
    transition(name='fade')
        .pm-sr(v-if="this.isMatchHiglightsReady" v-show="isPreMatchLoaded")
            h3 {{ $t('Match highlights') }}
            .pm-sr-team-wrap
                TeamSeasonStanding(
                    :position="this.$data.local_position_league"
                    :lastMatches="this.$data.local_last_matches_league"
                    :teamImage="$store.state.match.localImage"
                    :teamStandings="this.$data.local_standing_league"
                    :teamId="$store.state.match.localId"
                )
                TeamSeasonStanding(
                    :position="this.$data.visitor_position_league"
                    :lastMatches="this.$data.visitor_last_matches_league"
                    :teamImage="$store.state.match.visitorImage"
                    :teamStandings="this.$data.visitor_standing_league"
                    :teamId="$store.state.match.visitingId"
                )

    transition(name='fade')
        .pm-af-wrap(v-if="this.isLastMatchesReady"  v-show="isPreMatchLoaded")
            h3 {{ $t('Last matches') }}
            .pm-af
                TeamLastMatches(
                    :lastMatches="this.$data.local_last_matches"
                    :teamImage="$store.state.match.localImage"
                    club1=true 
                )
                TeamLastMatches(
                    :lastMatches="this.$data.visitor_last_matches"
                    :teamImage="$store.state.match.visitorImage"
                    club1=false 
                )
    transition(name='fade') 
        .pm-le(v-show="isPreMatchLoaded && isLeadersReady")
            h3 {{ $t('Stats leaders') }}
            .do-wrap.do-wrap--ov
                LeadersStat(:stat="leader_season_val", :decimals="1", :key="leader_season_val.name")
                LeadersStat(:stat="leader_season_score", :decimals="1", :key="leader_season_score.name")
                LeadersStat(:stat="leader_season_rb", :decimals="1", :key="leader_season_rb.name")
                LeadersStat(:stat="leader_season_asis", :decimals="1", :key="leader_season_asis.name")

    transition(name='fade')
        .pm-hi(v-show="initialPriorMatches && isPreMatchLoaded")
            h3 {{ $t('Prior matches') }}
            .pm-hi-data
                .pm-hi-global
                    img.pm-hi-global__shield(:src="$store.state.match.localImage")
                    .pm-hi-global-stat: LeaderGraph(:stat = "this.$data.total_victories") 
                    img.pm-hi-global__shield(:src="$store.state.match.visitorImage")

                .pm-hi-last.nav-day-match-wrap(v-if="this.$data.versus_last_matches.length > 0")
                    .pm-hi-last-match(
                        :class="[{'pm-hi-last-match--active': (match.id_edition >= $store.state.general.oldestACBLeagueEdition)}]",
                        role="button" 
                        v-for="match in this.$data.versus_last_matches"
                        @click="selectMatch(match)"
                        )
                        .ge-match.ge-match--hi
                            .pm-match_info
                                span.pm-match_info__comp {{ match.competition.official_name }}
                                span.pm-match_info__time {{ match.matchweek_descriptor }} - {{parsedDate(match.date,match.time)}}

                            .ge-match-info-wrap
                                .ge-match-info
                                    .ge-match-info__name 
                                        span {{ match.local_team.team_abbrev_name }}
                                    .ge-match-info-shield
                                        img(:src="match.local_image", :alt="match.local_team.team_abbrev_name")
                                    .ge-match-info__score
                                        span {{ match.score_local }}
                                .ge-match-info
                                    .ge-match-info__score
                                        span {{ match.score_visitor }}
                                    .ge-match-info-shield
                                        img(:src="match.visitor_image", :alt="match.visitor_team.team_abbrev_name")
                                    .ge-match-info__name 
                                        span {{ match.visitor_team.team_abbrev_name }}

                        i.pm-hi-last-match__arrow(v-if="match.id_edition >= $store.state.general.oldestACBLeagueEdition")
                            font-awesome-icon(icon="arrow-right")

    transition(name='fade')
        .pm-ts(v-show="isVersusReady && isPreMatchLoaded")
            h3 {{ $t('Team stats') }}
            Versus(:key="idMatch")



</template>
    
<style lang="sass">

.pm
    display: grid
    max-width: 1000px
    margin: 0 auto
    grid-auto-flow: row
    justify-conent: center
    padding: 4rem 1rem
        bottom: 16rem
    
    & > *
        padding-bottom: 8rem
        display: grid
        justify-items: center
        grid-gap: 2rem
        +breakpoint(medium)
            grid-gap: 3rem


    &-match_info
        font-size: 0.95rem
        color: $grey
        display: grid
        justify-items: center
        line-height: 1em
        grid-gap: 0.2rem
        padding-bottom: 0.4rem
        text-align: center 
        &__time
        &__comp
            font-weight: $bold
    
    &-sr
        &-team
            display: grid
            justify-items: center
            align-items: center
            grid-gap: 1rem 2rem
            grid-template-columns: 1fr
            grid-template-areas: "shield" "res" "table"

            +breakpoint(1300px)
                grid-template-columns: auto 1fr
                grid-template-rows: 80px 1fr
                grid-template-areas: "shield ." "table res"

                &:last-child
                    grid-template-areas: ". shield" "res table"


            &-wrap
                display: flex
                width: 100%
                justify-content: center
                flex-direction: column
                gap: 6rem 4rem
                
                +breakpoint(large)
                    flex-direction: row


            &-table
                width: 100%
                display: grid
                justify-items: center
                gap: 1rem
                grid-area: table

            
            &__shield
                grid-area: shield
                height: 80px

            &-res
                grid-area: res
                display: grid
                grid-gap: 1rem
                height: 100%
                align-content: space-between


                &-pos
                    display: grid
                    justify-items: center
                    padding-top: .5rem
                    
                    +breakpoint(1300px)
                        padding-top: 1.5rem
                    
                    &-num
                        display: flex
                        &__value
                            
                            +h1
                        &__ordinal
                            +h3
                            margin-top: .25em

                &-streak
                    display: grid
                    justify-items: center
                    grid-gap: 0.2rem

                    &-list
                        display: flex
                        gap: 0.1rem

    &-af
        display: grid
        grid-template-columns: 1fr
        width: 100%
        grid-gap: 3rem
        align-items: start

        +breakpoint(medium)
            grid-template-columns: 1fr 1fr
            grid-gap: 4rem
        &-team
            $res-width: 160px
            display: grid
            width: 100%
            grid-gap: 1rem
            justify-items: center
            +breakpoint(medium)
                justify-items: end
                &--visitor
                    justify-items: start

            &__shield
                width: $res-width
                display: flex
                justify-content: center

                +breakpoint(medium)
                    padding-right: 40px
                    padding-left: 40px

                & > img
                    width: 80px
                    height: 80px
                    object-fit: contain


            &-match
                $col-width: 40px
                display: grid
                grid-auto-flow: column
                border-bottom: 2px solid $light-grey
                align-items: center
                justify-content: center
                padding: 0.5rem 0
                    left: $col-width
                justify-items: center
                grid-template-columns: $col-width $col-width*2 $col-width $col-width
                grid-template-areas: "info info info arrow" "result score rival arrow"
                cursor: pointer
                

                &--visitor
                    grid-template-areas: "info info info arrow" "rival score result arrow"

                +breakpoint(medium)
                    justify-content: end
                    @at-root .pm-af-team--visitor &
                        justify-content: start

                &:last-child
                    border-bottom: initial
        
                &-list
                    display: grid
                    width: 100%
                &-info
                    grid-area: info

                &__arrow
                    grid-area: arrow
                    font-size: 1.2rem
                    color: $primary-color

                &__result
                    grid-area: result
                    
                &__rival
                    grid-area: rival
                    width: 100%
                    height: 40px
                    object-fit: contain
                &-score
                    display: flex
                    align-items: center
                    justify-content: center

                    &-wrap
                        grid-area: score
                        display: grid
                        grid-template-columns: 38px 38px
                        grid-template-rows: 32px
                        font-size: 1.4em
                        font-weight: $bold
                        color: $white

                    &--l
                        background-color: $local

                    &--v
                        background-color: $visitor



    &-hi
        &-data
            display: grid
            grid-gap: 2rem
            justify-conent: space-between
            justify-items: center
            width: 100%
            grid-template-columns: 1fr

            +breakpoint(medium)
                grid-template-columns: repeat(auto-fit, minmax(200px,1fr))


        &-global
            display: grid
            grid-template-columns: 80px auto 80px
            align-items: center

            &__shield
                width: 80px
                height: 80px
                object-fit: contain

        &-last
            display: grid
            width: 100%
            &-match
                padding: 0.5rem 0
                display: grid
                justify-content: center
                align-items: center
                border-bottom: 2px solid $light-grey
                grid-template-columns: 20px auto 20px
                grid-template-areas: ". match arrow"

                .ge-match
                    grid-area: match

            
                +breakpoint(medium)
                    padding-left: initial
                    grid-template-columns: auto 20px
                    grid-template-areas: "match arrow"



                &--active
                    cursor: pointer


                &:last-child
                    border-bottom: initial

                &__arrow
                    grid-area: arrow
                    font-size: 1.2rem
                    color: $primary-color


            &__comp
                max-height: 20px

 </style>
    
<script>
import api from "@/api/index.js";

import Advertisement from "@/components/subcomponents/general/Advertisement.vue";
import Loading from "@/components/subcomponents/general/Loading.vue";
import NavQuarter from "@/components/subcomponents/nav/NavQuarter.vue";
import LeadersStat from "@/components/subcomponents/leaders/LeadersStat.vue";
import LeaderGraph from "@/components/subcomponents/leaders/LeaderGraph.vue";


import Versus from "@/components/subcomponents/versus/Versus.vue";
import BoxScoreTable from "@/components/subcomponents/BoxScoreTable.vue"
// import StandingsTable from "@/components/subcomponents/StandingsTable.vue";
import TeamSeasonStanding from "@/components/subcomponents/prematch/TeamSeasonStanding.vue";
import TeamLastMatches from "@/components/subcomponents/prematch/TeamLastMatches.vue";


export default {
    name: "PreMatch",
    data() {
        return {
            // Match highlights
            local_position_league: 0,
            visitor_position_league: 0,
            local_last_matches_league: [],
            visitor_last_matches_league: [],

            local_standing_league: [],
            visitor_standing_league: [],
            isMatchHiglightsLoaded: false,

            // Initial requests status
            initialLocalLastMatches: false,
            initialVisitorLastMatches: false,
            initialStandingsLoaded: false,
            initialLeadersLoaded: false,

            initialPriorMatches: false,

            // Last matches
            local_last_matches: [],
            visitor_last_matches: [],

            // Leader stats
            leader_season_val: {
                local_team: [{ val: 0 }],
                visiting_team: [{ val: 0 }]
            },
            leader_season_score: {
                local_team: [{ val: 0 }],
                visiting_team: [{ val: 0 }]
            },
            leader_season_rb: {
                local_team: [{ val: 0 }],
                visiting_team: [{ val: 0 }]
            },
            leader_season_asis: {
                local_team: [{ val: 0 }],
                visiting_team: [{ val: 0 }]
            },

            // Prior matches
            total_victories: {
                local_team: [{ val: 0 }],
                visiting_team: [{ val: 0 }],
                name: this.$t('Wins')
            },
            versus_last_matches: [],

            // isVersusReady: false,

            // Global
            initialFail: false,
            initialTimer: null
        };
    },
    computed: {
        idMatch() {
            return this.$route.params.id_match;
        },
        actual() {
            return this.$store.state.general.actual;
        },
        isMatchHiglightsReady() {
            return (
                this.$data.local_standing_league.length > 0 &&
                this.$data.visitor_standing_league.length > 0
            )
        },
        isLastMatchesReady() {
            return (
                this.$data.local_last_matches.length > 0 ||
                this.$data.visitor_last_matches.length > 0
            )
        },

        isLeadersValReady() {
            return (
                this.$data.leader_season_val.local_team.length > 0 &&
                this.$data.leader_season_val.visiting_team.length > 0
            )
        },
        isLeadersScoreReady() {
            return (
                this.$data.leader_season_score.local_team.length > 0 &&
                this.$data.leader_season_score.visiting_team.length > 0
            )
        },
        isLeadersRbReady() {
            return (
                this.$data.leader_season_rb.local_team.length > 0 &&
                this.$data.leader_season_rb.visiting_team.length > 0
            )
        },
        isLeadersAsisReady() {
            return (
                this.$data.leader_season_asis.local_team.length > 0 &&
                this.$data.leader_season_asis.visiting_team.length > 0
            )
        },
        isLeadersReady() {
            return (
                this.isLeadersValReady &&
                this.isLeadersScoreReady &&
                this.isLeadersRbReady &&
                this.isLeadersAsisReady
            )
        },
        isVersusReady() {
            return this.$store.state.general.isVersusReady;
        },
        isPriorMatchesReady() {
            return this.$data.versus_last_matches.length > 0
        },
        initialCurrentForm() {
            return this.$data.initialLocalLastMatches && this.$data.initialVisitorLastMatches
        },
        // initialPriorMatches() {
        //     return this.$data.initialPriorMatches
        // },

        isPreMatchLoaded() {
            // console.log(
            //     this.initialCurrentForm,
            //     this.initialPriorMatches,
            //     this.$data.initialLeadersLoaded,
            //     this.$data.initialStandingsLoaded || this.$store.state.match.idCompetition != 1,
            //     this.$data.initialVersusLoaded
            // )
            if (
                this.initialCurrentForm &&
                this.initialPriorMatches &&
                this.$data.initialLeadersLoaded &&
                (this.$data.initialStandingsLoaded || this.$store.state.match.idCompetition != 1)
            ) {
                this.clearInitialTimer()
                return true
            } else {
                return false

            }



        },
        refreshSignal() {
            return this.$store.state.general.refreshSignal;
        },
    },

    methods: {
        // Global
        setInitialTimer() {
            this.timer = setTimeout(
                () => {
                    this.$data.initialFail = true
                },
                this.$store.state.general.requestTimeout
            )
        },
        clearInitialTimer() {
            if (this.initialTimer) {
                this.$data.initialFail = false
                clearTimeout(this.initialTimer)
            }
        },

        graphHasData(stats) {
            return stats.local_team[0].val && stats.visiting_team[0].val
        },
        selectMatch(match) {
            if (match.id_edition >= this.$store.state.general.oldestACBLeagueEdition) {
                if (this.$route) {
                    let routeData = '/' + this.$store.state.general.lang + '/' + match.id + '?match=true'

                    if (this.$store.state.general.isApp) {
                        routeData += '&app=true'
                    }
                    if (this.$store.state.general.navigation_prematch) {
                        routeData += ('&prematch=' + this.$store.state.general.navigation_prematch)

                    } else {
                        routeData += ('&prematch=' + this.idMatch)

                    }
                    window.location.href = routeData;
                }
                this.$store.commit("general/setNav", 0);
            }
        },
        parsedDate(date, time) {
            let match_date = new Date((date + time) * 1000)
            function pad(s) { return (s < 10) ? '0' + s : s; }
            return [pad(match_date.getDate()), pad(match_date.getMonth() + 1), match_date.getFullYear()].join('/')
        },

        getMatchHighlights() {
            this.getPrematchStandings()
            this.getLastMatchesLeague()
        },

        // Match highlights

        getLastMatchesLeague() {
            let params = {
                numberOfMatches: 5,
                idCompetition: this.actual.competition.id,
                idEdition: this.actual.edition.id,
                idClub1: this.$store.state.match.localIdClub,
                dateTo: this.$store.state.match.start_date
            }
            api.prematch.getLastMatches(params, this.$store.state.match.localId)
                .then(data => {
                    this.$data.local_last_matches_league = data;
                });
            params['idClub1'] = this.$store.state.match.visitingIdClub
            api.prematch.getLastMatches(params, this.$store.state.match.visitingId)
                .then(data => {
                    this.$data.visitor_last_matches_league = data;
                });
        },

        getPrematchStandings() {
            if (this.actual.competition.id == 1) {
                api.competition.getRoundList(this.actual.edition.id, this.actual.competition.id).then((data) => {
                    if (data) {
                        const matchweek = data.find((round) => round.id == this.actual.round.id);
                        const matchweek_index = data.findIndex((round) => round.id == this.actual.round.id);
                        if ((matchweek_index < data.length - 1) && (matchweek.descriptor.includes("Jornada") || matchweek.descriptor.includes("Semana"))) {
                            if (matchweek.id_edition == this.$store.state.general.currentACBLeagueEdition) {
                                const current_matchweek = data.find((round) => round.id == this.$store.state.general.actualCompRound);
                                if (matchweek.num_matchweek <= current_matchweek.num_matchweek) {
                                    this.getPreviousMatchWeekStandings(data[matchweek_index + 1])
                                } else {
                                    this.getCurrentMatchWeekStandings()
                                }
                            } else {
                                this.getPreviousMatchWeekStandings(data[matchweek_index + 1])
                            }
                        } else {
                            this.$data.isMatchHiglightsLoaded = true
                        }
                    }
                    this.$data.initialStandingsLoaded = true

                });
            }
        },
        getNextStandingPositions(standing, position) {
            const index = standing.findIndex(team => team.position === position);

            let startIndex = index - 2;
            let endIndex = index + 2;

            if (startIndex < 0) {
                startIndex = 0;
                endIndex = Math.min(4, standing.length - 1);
            }

            if (endIndex >= standing.length) {
                endIndex = standing.length - 1;
                startIndex = Math.max(0, endIndex - 4);
            }
            return standing.slice(startIndex, endIndex + 1);
        },
        getPreviousMatchWeekStandings(previous_round) {
            api.competition.getStandings(this.actual.edition.id, this.actual.competition.id, previous_round.id, previous_round.id_phase).then((data) => {
                if (data) {
                    this.$data.local_position_league = data.find(team => team.id_team === this.$store.state.match.localId).position
                    this.$data.visitor_position_league = data.find(team => team.id_team === this.$store.state.match.visitingId).position
                    this.$data.local_standing_league = this.getNextStandingPositions(data, this.$data.local_position_league)
                    this.$data.visitor_standing_league = this.getNextStandingPositions(data, this.$data.visitor_position_league)
                    this.$data.isMatchHiglightsLoaded = true
                }
            });
        },

        getCurrentMatchWeekStandings() {
            api.competition.getActualStandings().then((data) => {
                if (data) {
                    this.$data.local_position_league = data.find(team => team.id_team === this.$store.state.match.localId).position
                    this.$data.visitor_position_league = data.find(team => team.id_team === this.$store.state.match.visitingId).position

                    this.$data.local_standing_league = this.getNextStandingPositions(data, this.$data.local_position_league)
                    this.$data.visitor_standing_league = this.getNextStandingPositions(data, this.$data.visitor_position_league)
                }
            });
        },
        // Last matches
        getCurrentForm() {
            let params = {
                numberOfMatches: 5,
                idCompetition: this.actual.competition.id,
                idEdition: this.actual.edition.id,
                idClub1: this.$store.state.match.localIdClub,
                dateTo: this.$store.state.match.start_date
            }
            api.prematch.getLastMatches(params, this.$store.state.match.localId)
                .then(data => {
                    this.$data.local_last_matches = data;
                    this.$data.initialLocalLastMatches = true
                });
            params['idClub1'] = this.$store.state.match.visitingIdClub
            api.prematch.getLastMatches(params, this.$store.state.match.visitingId)
                .then(data => {
                    this.$data.visitor_last_matches = data;
                    this.$data.initialVisitorLastMatches = true
                });
        },

        // Stats leaders
        async getSeasonLeaders() {
            let params = {
                idCompetition: this.actual.competition.id,
                idEdition: this.actual.edition.id,
                idTeam: this.$store.state.match.localId,
                dateTo: this.$store.state.match.start_date
            };
            const [localLeadersData, visitorLeadersData] = await Promise.all([
                api.match.getPreMatchSeasonLeaders(params),
                api.match.getPreMatchSeasonLeaders({ ...params, idTeam: this.$store.state.match.visitingId }),
            ]);
            if (localLeadersData && visitorLeadersData) {
                const data = api.match.parsePreMatchSeasonLeaders(localLeadersData, visitorLeadersData)
                this.$data.leader_season_val = data.val;
                this.$data.leader_season_score = data.score;
                this.$data.leader_season_rb = data.rb;
                this.$data.leader_season_asis = data.asis;
            }
            this.$data.initialLeadersLoaded = true
        },

        getPriorMatches() {
            let params = {
                idCompetition: this.actual.competition.id,
                idClub1: this.$store.state.match.localIdClub,
                idClub2: this.$store.state.match.visitingIdClub,
                dateTo: this.$store.state.match.start_date
            }
            if (this.actual.competition.id == 1) {
                params.idClub1isLocal = true
            }
            api.prematch.getPriorMatches(params)
                .then(data => {
                    this.$data.total_victories.local_team[0].val = data.club1_victories;
                    this.$data.total_victories.visiting_team[0].val = data.club2_victories;
                    this.$data.versus_last_matches = data.matches;
                    this.$data.initialPriorMatches = true
                });

        },
        getActual() {
            this.$data.loading = true
            api.competition.getActual()
                .then((data) => {
                    api.competition.getCurrentRound(data.actual.edition.id, data.actual.competition.id)
                        .then((data) => {
                            this.$store.commit('general/setActualCompRound', data.id)
                        })
                    api.competition.getCurrentWeek(data.actual.edition.id, data.actual.competition.id)
                        .then((data) => {
                            this.$store.commit('general/setActualCompWeek', data.id)
                        })
                    this.$data.loading = false
                }
                )
        },
    },
    watch: {
        refreshSignal(newValue) {
            if (newValue) {
                if (this.$store.state.general.refreshing) {
                    this.getMatchHighlights();
                    this.getCurrentForm();
                    this.getSeasonLeaders();
                    this.getPriorMatches();
                }
            }
        },
        '$store.state.general.actualCompRound': function (newVal) {
            if (newVal != 1) {
                this.getPrematchStandings();
            }
        },
    },
    created() {
        this.setInitialTimer()
        this.getMatchHighlights();
        this.getCurrentForm();
        this.getSeasonLeaders();
        this.getPriorMatches();
    },
    mounted() {
        this.$parent.triggerGlobalRefresh()
        this.$parent.goTop();
    },
    components: {
        Loading,
        NavQuarter,
        LeadersStat,
        LeaderGraph,
        Versus,
        BoxScoreTable,
        Advertisement,
        TeamSeasonStanding,
        TeamLastMatches
    }
};
</script>